import api from 'app/api';

import getAll from './get-companies';

import getAllWithJoin from './get-companies-with-join';
import deleteCompany from './delete-company';
import addCompany from './add-company';
import getCompanyWithDocument from './get-company-with-document';
import editCompany from './edit-company';

export const companiesApi = api.injectEndpoints({
    endpoints: (builder) => ({
        getCompanies: getAll(builder),
        getCompaniesWithJoin: getAllWithJoin(builder),
        addCompany: addCompany(builder),
        getCompanyWithDocument: getCompanyWithDocument(builder),
        editCompany: editCompany(builder),
        deleteCompany: deleteCompany(builder),
    }),
});

export const {
    useGetCompaniesQuery,
    useGetCompaniesWithJoinQuery,
    useDeleteCompanyMutation,
    useAddCompanyMutation,
    useEditCompanyMutation,
    useGetCompanyWithDocumentQuery,
} = companiesApi;
